export const OPTION_GRID_GRID_VIEW = "OPTION_GRID_GRID_VIEW";
export const OPTION_GRID_LIST_VIEW = "OPTION_GRID_LIST_VIEW";
export const OPTION_GRID_SINGLE_COLUMN_VIEW = "OPTION_GRID_SINGLE_COLUMN_VIEW";

// viewports
export const VIEWPORT_SMALL = "VIEWPORT_SMALL";
export const VIEWPORT_MEDIUM = "VIEWPORT_MEDIUM";
export const VIEWPORT_LARGE = "VIEWPORT_LARGE";
